import { QcBizSubMenuSchema, SubMenuSchema } from "../guest/SubMenu";
import { z } from "zod";

export type MainMenu = z.infer<typeof MainMenuSchema>;
export const MainMenuSchema = z.object({
  id: z.number(),
  tenant_id: z.number(),
  name_dict: z.string(),
  icon: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? ""),
  name: z.string(),
  code: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  is_icon_with_letter: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  required_show_submenu: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  sub_menu: z
    .array(z.lazy(() => SubMenuSchema))
    .optional()
    .transform((value) => value ?? []),
});

export type QcBizMainMenu = z.infer<typeof QcBizMainMenuSchema>;
export const QcBizMainMenuSchema = z.object({
  code: z.string().optional(),
  current_lang_cd: z.string().optional(),
  icon: z.string().optional(),
  icon_code: z.string().optional(),
  id: z.number().optional(),
  is_icon_with_letter: z.boolean().optional(),
  name: z.string().optional(),
  name_dict: z.string().optional(),
  required_show_submenu: z.boolean().optional(),
  sub_menu: z.array(z.lazy(() => QcBizSubMenuSchema)).optional(),
  tenant_id: z.number().optional(),
});

export type QcBizMainMenuForQcBizInquiry = z.infer<typeof QcBizMainMenuForQcBizInquirySchema>;
export const QcBizMainMenuForQcBizInquirySchema = z.object({
  icon: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  id: z.number(),
  name: z.string(),
  name_dict: z.string(),
  tenant_id: z.number(),
});
